import { render } from "./AdminNav.vue?vue&type=template&id=5c54d61c&scoped=true"
import script from "./AdminNav.vue?vue&type=script&lang=js"
export * from "./AdminNav.vue?vue&type=script&lang=js"

import "./AdminNav.vue?vue&type=style&index=0&id=5c54d61c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c54d61c"

export default script